<sub-nav [menu]="menu" [canCollapse]="false"></sub-nav>
<div class="container-fluid subnav-padding">
  <router-outlet></router-outlet>
</div>
